import { FC } from 'react';

import { AppFormattedMessage } from '../../../components/app-formatted-message/index';
import Button from '../../../components/button/index';

export type DeleteShareClassModalProps = {
  onClose: () => void;
  onSuccess: () => void;
};

export const DeleteShareClassModal: FC<DeleteShareClassModalProps> = ({ onClose, onSuccess }) => (
  <div className="m-2 flex w-full min-w-[300px] flex-col gap-8 rounded bg-white p-4 xlg:w-[453px]">
    <div className="flex flex-col gap-1">
      <span className="text-xl font-[550] text-gray-700">
        <AppFormattedMessage id="DELETE_SHARE_CLASS" />
      </span>
      <span className="text-xs font-[450] text-gray-500">
        <AppFormattedMessage id="SHARE_CLASS_DATA_LOSS_WARNING" />
      </span>
    </div>
    <div className="flex h-11 justify-end gap-4">
      <Button
        className="h-full w-fit rounded border border-gray-300 px-6 py-[10px] text-sm font-[450] text-gray-700"
        onClick={onClose}
        styleType="NONE"
      >
        <AppFormattedMessage id="NO_KEEP_3" />
      </Button>
      <Button
        className="h-full w-fit bg-fireside-600 px-6 py-[10px] text-sm font-[550] text-white"
        data-permission-required
        onClick={onSuccess}
        styleType="NONE"
      >
        <AppFormattedMessage id="CONFIRM_DELETE" />
      </Button>
    </div>
  </div>
);
